var exports = {
  "Qs": "x127c5a35--de854b--content",
  "nV": "x127c5a35--de854b--gallery",
  "vw": "x127c5a35--de854b--rounted_gallery",
  "xe": "x127c5a35--de854b--space",
  "VS": "x127c5a35--de854b--empty_photo",
  "wx": "x127c5a35--de854b--header",
  "rd": "x127c5a35--de854b--header--redesign",
  "BI": "x127c5a35--de854b--favorite",
  "_Y": "x127c5a35--de854b--favorite--redesign",
  "$_": "x127c5a35--de854b--media",
  "Nr": "x127c5a35--de854b--card",
  "YI": "x127c5a35--de854b--card--redesign",
  "ne": "x127c5a35--de854b--controls",
  "bu": "x127c5a35--de854b--commercial-info-ready-business-wrapper",
  "D7": "x127c5a35--de854b--shields_wrapper",
};

module.exports = exports;
